import { customAxiosBE } from "../config";

export async function assignLineToStationAPI(data) {
    return customAxiosBE.post('/station-line-assignment', data);
}

export async function getAssignmentsByCarrierAPI(carrierOperatorId) {
    return customAxiosBE.get(`/station-line-assignment/carrier/${carrierOperatorId}`);
}

export async function getAssignmentsByStationAPI(stationOperatorId) {
    return customAxiosBE.get(`/station-line-assignment/station/${stationOperatorId}`);
}

export async function getAssignedLineIdsByStationAPI(stationOperatorId) {
    return customAxiosBE.get(`/station-line-assignment/station/${stationOperatorId}/line-ids`);
}

export async function getAssignedLineIdsByCarrierAndStationAPI(carrierOperatorId, stationOperatorId) {
    return customAxiosBE.get(`/station-line-assignment/carrier/${carrierOperatorId}/station/${stationOperatorId}/line-ids`);
}

export async function getAssignmentsByCarrierAndStationAPI(carrierOperatorId, stationOperatorId) {
    return customAxiosBE.get(`/station-line-assignment/carrier/${carrierOperatorId}/station/${stationOperatorId}`);
}

export async function toggleAssignmentActiveAPI(id) {
    return customAxiosBE.put(`/station-line-assignment/${id}/toggle-active`);
}

export async function deleteAssignmentAPI(id) {
    return customAxiosBE.delete(`/station-line-assignment/${id}`);
}
